import * as React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import classNames from 'classnames';

export type Props = {
  onRequestClose: () => void;
  isOpen: boolean;
  children: React.ReactNode;
  size?: 'S' | 'M' | 'L';
};

export const Base = (props: Props) => {
  const { isOpen, children, size } = props;

  return (
    <Transition.Root appear show={isOpen} as={React.Fragment}>
      <Dialog
        as="div"
        className="relative z-30"
        open={props.isOpen}
        onClose={props.onRequestClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-auto">
          <div className="flex min-h-full items-center justify-center p-s text-center sm:p-0 lg:p-xxl">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={classNames(
                  'relative w-full rounded-lg text-left shadow-xl transition-all bg-regular',
                  {
                    'max-w-large-modal tablet-max:max-w-medium-modal mobile:max-w-small-modal':
                      size === 'L',
                    'max-w-medium-modal mobile:max-w-small-modal': size === 'M',
                    'max-w-small-modal': size === 'S',
                    'max-w-sm sm:max-w-xl': !size,
                  }
                )}
              >
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Base;
